import React from "react";
import { Button } from "../ButtonElements";
import {
  InfoContainer,
  InfoWrapper,
  InfoRow,
  Column1,
  Column2,
  TextWrapper,
  TopLine,
  Heading,
  Subtitle,
  BtnWrap,
  ImgWrap,
  Img,
} from "./InfoElements";

const InfoSection = ({
  lightBg,
  splitBg,
  imgFullHeight,
  imgStart,
  topLine,
  lightText,
  headline,
  description,
  buttonLabel,
  href,
  img,
  alt,
  id,
  primary,
  darkText,
  dark,
  dark2,
}) => {
  //console.log(primary);
  return (
    <>
      <InfoContainer lightBg={lightBg} splitBg={splitBg} id={id}>
        <InfoWrapper $imgFull={imgFullHeight}>
          <InfoRow imgStart={imgStart} $imgFull={imgFullHeight}>
            <Column1>
              <TextWrapper>
                <TopLine>{topLine}</TopLine>
                <Heading lightText={lightText}>{headline}</Heading>
                <Subtitle darkText={darkText}>{description}</Subtitle>
                <BtnWrap>
                  {href ? (
                    <Button as="a" href={href} target="_blank" rel="noopener noreferrer"
                      primary={primary ? 1 : 0} dark={dark ? 1 : 0} dark2={dark2 ? 1 : 0}>
                      {buttonLabel}
                    </Button>
                  ) : (
                    <Button
                      to="home"
                      smooth={true}
                      duration={500}
                      spy={true}
                      exact="true"
                      offset={-80}
                      primary={primary ? 1 : 0}
                      dark={dark ? 1 : 0}
                      dark2={dark2 ? 1 : 0}
                    >
                      {buttonLabel}
                    </Button>
                  )}
                </BtnWrap>
              </TextWrapper>
            </Column1>
            <Column2 $imgFull={imgFullHeight}>
              <ImgWrap $imgFull={imgFullHeight}>
                <Img src={img} alt={alt} $imgFull={imgFullHeight} />
              </ImgWrap>
            </Column2>
          </InfoRow>
        </InfoWrapper>
      </InfoContainer>
    </>
  );
};

export default InfoSection;
